import router from "./router";
import TokenStorage from "./common/TokenStorage";
import store from "./store";

router.beforeEach((to, from, next) => {
    if (to.path !== window.location.pathname && to.meta.wxApi) {
        window.location.assign(to.path);
    }
    if (to.path === '/auth') {
        next();
        return;
    }
    if (TokenStorage.isRefresh()) {
        next({
            replace: true,
            path: '/auth',
            query: {
                redirect: encodeURIComponent(to.path)
            }
        })
    } else if (!store.state.userInfo){
        store.dispatch('getUserInfo').then(() => {
            next();
        }).catch(() => {
            TokenStorage.clearToken();
            next({
                replace: true,
                path: '/auth',
                query: {
                    redirect: encodeURIComponent(to.path)
                }
            })
        })
    } else {
        next();
    }
});
